import { render, staticRenderFns } from "./SeveranceDetail.vue?vue&type=template&id=641d4a60"
import script from "./SeveranceDetail.vue?vue&type=script&lang=js"
export * from "./SeveranceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports